import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  stripeBtn: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8
    }
  }
}));
